// extracted by mini-css-extract-plugin
export default {"container":"app_container__DK3TJ","child":"app_child__h5ow3"};